var _style, _defs, _polygon, _defs2, _polygon2, _defs3, _path, _defs4, _polygon3, _defs5, _polygon4, _defs6, _polygon5, _defs7, _polygon6, _defs8, _polygon7, _defs9, _polygon8, _defs10, _path2, _defs11, _path3, _defs12, _polygon9, _defs13, _defs14, _polygon10, _path4, _defs15, _polygon11, _defs16, _polygon12, _defs17, _polygon13, _path5, _path6, _path7, _defs18, _path8, _path9, _defs19, _polygon14, _defs20, _polygon15, _defs21, _polygon16, _defs22, _polygon17, _defs23, _polygon18, _defs24, _polygon19, _defs25, _polygon20, _defs26, _path10, _defs27, _polygon21, _defs28, _polygon22, _defs29, _polygon23, _defs30, _polygon24, _defs31, _polygon25, _defs32, _polygon26, _g, _defs33, _defs34, _path11, _defs35, _defs36, _path12, _defs37, _path13, _defs38, _path14, _defs39, _polygon27, _g2, _defs40, _polygon28, _defs41, _path15, _defs42, _defs43, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFishResult2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 899.94 350",
    style: {
      enableBackground: "new 0 0 899.94 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\n\t.st1{clip-path:url(#SVGID_5_);fill:url(#SVGID_6_);}\n\t.st2{opacity:0.1;}\n\t.st3{clip-path:url(#SVGID_8_);fill:#FFFFFF;}\n\t.st4{clip-path:url(#SVGID_10_);fill:url(#SVGID_11_);}\n\t.st5{clip-path:url(#SVGID_13_);fill:url(#SVGID_14_);}\n\t.st6{clip-path:url(#SVGID_16_);fill:url(#SVGID_17_);}\n\t.st7{clip-path:url(#SVGID_19_);fill:url(#SVGID_20_);}\n\t.st8{clip-path:url(#SVGID_23_);fill:url(#SVGID_24_);}\n\t.st9{clip-path:url(#SVGID_26_);fill:url(#SVGID_27_);}\n\t.st10{clip-path:url(#SVGID_29_);fill:#FFFFFF;}\n\t.st11{clip-path:url(#SVGID_31_);fill:#FFFFFF;}\n\t.st12{clip-path:url(#SVGID_33_);fill:url(#SVGID_34_);}\n\t.st13{opacity:0.9;}\n\t.st14{clip-path:url(#SVGID_36_);}\n\t.st15{clip-path:url(#SVGID_38_);fill:url(#SVGID_39_);}\n\t.st16{clip-path:url(#SVGID_41_);fill:url(#SVGID_42_);}\n\t.st17{clip-path:url(#SVGID_44_);fill:url(#SVGID_45_);}\n\t.st18{clip-path:url(#SVGID_47_);fill:url(#SVGID_48_);}\n\t.st19{fill:#680516;}\n\t.st20{fill:#959EA3;}\n\t.st21{fill:#9A324B;}\n\t.st22{opacity:0.2;}\n\t.st23{clip-path:url(#SVGID_50_);fill:#FFFFFF;}\n\t.st24{fill:#3F0011;}\n\t.st25{clip-path:url(#SVGID_52_);fill:url(#SVGID_53_);}\n\t.st26{clip-path:url(#SVGID_55_);fill:url(#SVGID_56_);}\n\t.st27{clip-path:url(#SVGID_58_);fill:url(#SVGID_59_);}\n\t.st28{clip-path:url(#SVGID_61_);fill:url(#SVGID_62_);}\n\t.st29{clip-path:url(#SVGID_64_);fill:url(#SVGID_65_);}\n\t.st30{clip-path:url(#SVGID_67_);fill:url(#SVGID_68_);}\n\t.st31{clip-path:url(#SVGID_70_);fill:url(#SVGID_71_);}\n\t.st32{clip-path:url(#SVGID_73_);fill:#FFFFFF;}\n\t.st33{clip-path:url(#SVGID_75_);fill:url(#SVGID_76_);}\n\t.st34{clip-path:url(#SVGID_78_);fill:url(#SVGID_79_);}\n\t.st35{clip-path:url(#SVGID_81_);fill:url(#SVGID_82_);}\n\t.st36{clip-path:url(#SVGID_84_);fill:url(#SVGID_85_);}\n\t.st37{clip-path:url(#SVGID_87_);fill:url(#SVGID_88_);}\n\t.st38{clip-path:url(#SVGID_90_);fill:url(#SVGID_91_);}\n\t.st39{opacity:0.2;clip-path:url(#SVGID_93_);}\n\t.st40{clip-path:url(#SVGID_95_);fill:#FFFFFF;}\n\t.st41{opacity:0.2;clip-path:url(#SVGID_97_);}\n\t.st42{clip-path:url(#SVGID_99_);fill:#FFFFFF;}\n\t.st43{clip-path:url(#SVGID_101_);}\n\t.st44{clip-path:url(#SVGID_103_);fill:#FFFFFF;}\n\t.st45{clip-path:url(#SVGID_105_);fill:url(#SVGID_106_);}\n\t.st46{clip-path:url(#SVGID_109_);fill:url(#SVGID_110_);}\n\t.st47{clip-path:url(#SVGID_112_);}\n\t.st48{opacity:0.2;clip-path:url(#SVGID_114_);}\n\t.st49{clip-path:url(#SVGID_116_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M577.56,109.68c-0.83,0-1.64,0-2.47,0.01c-36.03,0.28-71.58,4.22-98.78,8.23 c-25.15,3.72-43.18,7.51-47.86,8.54c-0.8,0.16-1.2,0.26-1.2,0.26c-80.38,19.34-249.44,78.27-276.93,87.91 c-3.05,1.07-6.44,0.62-9.07-1.27c-0.76-0.55-1.54-1.15-2.37-1.82c-7.64-6.18-17.28-16.66-17.28-16.66 c-2.08-2.17-4.19-4.3-6.35-6.39c-2.66-2.61-5.39-5.16-8.15-7.68c-24.71-22.39-52.56-40.44-72.54-51.62 c-8.02-4.5-14.75-7.89-19.52-10c-0.03-0.03-0.06-0.03-0.08-0.05c-18.95-8.42-15.24,0.1-13.44,3.83 c2.58,10.21,6.33,18.19,4.32,26.19c0,0,4.28-3.16,8.29-5.03c1.66-0.76,3.28-1.31,4.53-1.31c0,0-0.03,5.83,2.27,11.26 c19.96,28.84,45.03,62.82,45,92.57c-0.03,26.53-21.75,80.36-29.29,98.29c-1.2,2.82,1.41,5.76,4.35,4.92 c1.43-0.41,2.87-0.93,4.37-1.56c0.29-0.13,0.58-0.26,0.89-0.41c0.34-0.15,0.7-0.31,1.05-0.49c5.55-2.63,11.38-6.62,17.22-11.41 c26.95-22.1,54.43-61.37,57.27-65.33c0.91-1.28,2.14-3.15,3.58-5.35c1.72-2.65,3.78-5.76,6.05-8.85 c4.02-5.48,8.68-10.9,13.27-13.58c9.15-5.32,53.36,0.28,53.88,0.28s7.21,10.09,7.21,10.09c1.88,0.03,3.76,0.08,5.6,0.13 c1.85,0.03,3.68,0.08,5.5,0.15c1.23,0.03,2.47,0.06,3.67,0.11c3.37,0.1,6.67,0.23,9.9,0.37c1.95,0.08,3.88,0.16,5.78,0.26 c3.78,0.18,7.46,0.39,11.05,0.6c1.87,0.12,3.7,0.23,5.52,0.36c2.17,0.13,4.3,0.27,6.39,0.44c2.71,0.2,5.34,0.41,7.9,0.62 c0.96,0.08,1.9,0.16,2.82,0.24c1.49,0.13,2.97,0.26,4.41,0.39c7.04,0.67,13.49,1.36,19.31,2.08l0.41,0.05l73.48,7.53l2.5,0.26 c33.46,5.29,73.54,7.22,115.87,9.54c-12.14,11.5-30.3,26.19-48.88,34.06c0,0,20.9,8.73,59.65-4.66 c18.08-6.23,41.28-16.42,61.97-26.58c14.65,0.37,25.14,0.5,28.9,0.55c1.01,0.02,1.53,0.02,1.53,0.02 c0.21,0.03,0.42,0.1,0.62,0.19c8.16,0.8,38.72,3.41,74.29,2.63c0.52-0.02,1.06-0.03,1.61-0.05c0.45-0.03,0.91-0.05,1.4-0.08 c0.05,0,0.11,0,0.16-0.01c0.49-0.01,1.01-0.06,1.53-0.1c2.47-0.19,5.21-0.47,8.18-0.86c0.63-0.06,1.28-0.15,1.95-0.24 c1.59-0.21,3.23-0.44,4.92-0.7c0.99-0.14,2-0.31,3.02-0.47c4.58-0.71,9.48-1.56,14.59-2.52c1.69-0.32,3.39-0.63,5.11-0.97 c1.23-0.24,2.48-0.49,3.75-0.73c1.25-0.25,2.5-0.5,3.76-0.76c2.19-0.44,4.4-0.89,6.62-1.36c1.48-0.31,2.97-0.62,4.46-0.94 c1.22-0.26,2.43-0.52,3.65-0.8c3.15-0.66,6.28-1.36,9.41-2.06c1.17-0.26,2.34-0.52,3.51-0.8c2.14-0.47,4.27-0.96,6.38-1.44 c0.94-0.23,1.88-0.44,2.82-0.67c0.16-0.03,0.32-0.08,0.49-0.11c1.14-0.26,2.27-0.52,3.39-0.8c2.43-0.57,4.84-1.14,7.19-1.7 c1.31-0.32,2.63-0.63,3.91-0.94c3.31-0.81,6.51-1.59,9.56-2.35c0.47-0.12,0.94-0.23,1.41-0.36c2.32-0.57,4.54-1.13,6.67-1.69 c0.5-0.13,1.01-0.24,1.49-0.37c0.36-0.1,0.71-0.18,1.05-0.28c0.66-0.16,1.3-0.34,1.93-0.5c2.74-0.71,5.27-1.38,7.53-2 c0.54-0.15,1.04-0.28,1.54-0.42c4.92-1.35,8.34-2.37,9.72-2.89c0.7-0.26,1.38-0.55,2.04-0.83c0.03-0.02,0.06-0.03,0.1-0.05 c0.65-0.29,1.28-0.58,1.9-0.89c0.65-0.31,1.27-0.63,1.87-0.97c0.08-0.03,0.16-0.08,0.24-0.13c0.52-0.29,1.04-0.6,1.53-0.89 c0.54-0.32,1.05-0.67,1.56-0.99c0.53-0.36,1.04-0.73,1.54-1.09c0.39-0.29,0.78-0.59,1.15-0.89c0.36-0.29,0.71-0.57,1.05-0.86 c0.45-0.37,0.89-0.76,1.31-1.14c0.13-0.13,0.26-0.25,0.39-0.37c0.11-0.1,0.23-0.21,0.34-0.33c0.29-0.26,0.55-0.52,0.83-0.79 c0.26-0.26,0.52-0.54,0.78-0.8c0.37-0.37,0.71-0.75,1.06-1.12c0.42-0.47,0.83-0.94,1.2-1.4c0.68-0.85,1.32-1.66,1.87-2.45 c0.02-0.02,0.02-0.02,0.03-0.03c0.24-0.34,0.47-0.68,0.7-1.02l0.21-0.36l0.27-0.46l0.37-0.6l0.78-1.27l0.28-0.45l0.13-0.2 l0.06-0.11l1.14-1.87h0.01l1.2-1.98l0.05-0.08c0.03,0,0.05,0,0.08,0.02c0.06,0,0.14,0.02,0.21,0.02 c0.36,0.05,0.71,0.1,1.07,0.13c21.05,2.26,36.79-4.3,47.51-11.73c7.69-5.34,12.82-11.13,15.48-14.46c6.49-8.11,0-11.36,0-11.36 c-7.32-4.46-14.91-8.71-22.77-12.77c-4.35-2.24-8.78-4.43-13.27-6.54c-58.39-27.62-127.69-44.87-187.88-53.91 c-4.51-0.68-8.97-1.31-13.37-1.9c-0.67-0.08-1.33-0.18-2-0.26c-2.26-0.29-4.51-0.58-6.73-0.86c-1.43-0.18-2.87-0.34-4.29-0.52 c-1.43-0.16-2.85-0.32-4.25-0.47c-9.86-1.11-19.36-1.95-28.33-2.58c-1.28-0.1-2.56-0.18-3.83-0.26 c-7.35-0.47-14.33-0.78-20.9-0.94c-0.21,0-0.42-0.02-0.63-0.02c-2.09-0.05-4.12-0.08-6.12-0.1c-1.25-0.01-2.47-0.01-3.68-0.01 L577.56,109.68L577.56,109.68z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.5557,
    y1: 185.3933,
    x2: 279.1785,
    y2: 185.3933,
    gradientTransform: "matrix(5.0733 145.0968 -145.0968 5.0733 25937.0859 -41112.9102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F7784"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5573,
    style: {
      stopColor: "#36545F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9933,
    style: {
      stopColor: "#27343A"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "902.43,77.99 911.96,350.4 -2.87,382.39 -12.39,109.98  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M790.58,213.67c-3.86,0.8-7.37,1.41-10.55,1.9c-22.64,3.49-29.49-0.12-39.21-1.91 c-10.91-2.04-16.4,1.19-21.92,4.41c-6.8,3.97-13.66,7.94-30.77,2.08c-24.77-8.49-51.36-9.69-58.34-3.03 c-4.92,4.69-2.47,8.39-0.57,12.97c4.95,11.94-4.22,16.91-10.09,18.22c-6.27,1.41-12.25,3.88-17.59,7.42 c-9.22,6.12-25.12,14.78-42.89,23.48c14.65,0.37,25.14,0.5,28.9,0.55c1.01,0.02,1.53,0.02,1.53,0.02 c0.21,0.03,0.42,0.1,0.62,0.19c8.16,0.8,38.72,3.41,74.29,2.63c0.52-0.02,1.06-0.03,1.61-0.05c0.45-0.03,0.91-0.05,1.4-0.08 c0.05,0,0.11,0,0.16-0.01c0.49-0.01,1.01-0.06,1.53-0.1c2.47-0.19,5.21-0.47,8.18-0.86c0.63-0.06,1.28-0.15,1.95-0.24 c1.59-0.21,3.23-0.44,4.92-0.7c0.99-0.14,2-0.31,3.02-0.47c2.55-0.41,5.21-0.84,7.95-1.31c2.16-0.37,4.38-0.78,6.64-1.2 c1.02-0.19,2.03-0.39,3.07-0.58l2.04-0.39c1.23-0.24,2.48-0.49,3.75-0.73c1.1-0.21,2.19-0.44,3.31-0.67 c0.15-0.03,0.31-0.06,0.45-0.1c2.19-0.44,4.4-0.89,6.62-1.36c0.52-0.12,1.04-0.21,1.56-0.32c0.96-0.19,1.93-0.41,2.9-0.62 c1.22-0.26,2.43-0.52,3.65-0.8c0.26-0.05,0.54-0.11,0.8-0.18c2.89-0.6,5.74-1.25,8.62-1.88c0.24-0.05,0.49-0.11,0.73-0.16 c0.92-0.21,1.85-0.42,2.77-0.63c1.19-0.26,2.37-0.54,3.55-0.81c0.94-0.19,1.88-0.42,2.82-0.63c0.94-0.23,1.88-0.44,2.82-0.67 c0.16-0.03,0.32-0.08,0.49-0.11c0.83-0.2,1.64-0.37,2.45-0.57c0.32-0.08,0.63-0.15,0.94-0.23c2.43-0.57,4.84-1.14,7.19-1.7 c1.31-0.32,2.63-0.63,3.91-0.94c3.31-0.81,6.51-1.59,9.56-2.35c0.47-0.12,0.94-0.23,1.41-0.36c2.32-0.57,4.54-1.13,6.67-1.69 c0.5-0.13,1.01-0.24,1.49-0.37c2.3-0.6,3.62-0.45,6.08-0.3c1.55,0.09,3.55,0.18,6.53,0.09c1.2-0.03,2.19-0.02,3,0.05 c4.28,2.27,11.33,3.25,16.86,2.76c8.5-0.78,5.55-7.22,5.4-10.56c-0.15-3.34-0.24-8.34,3.89-12.22 c4.14-3.88,9.56-4.19,12.17-5.19c1.75-0.68,2.24-2.63,1.95-4.53c17.7,0.37,31.22-5.54,40.76-12.16 c-3.34-3.23-10.79-5.55-26.51-2.29c-9.19,1.91-18.74,0.66-28.92-0.6c-6.41-0.79-13.07-1.58-20.06-1.58 C801.08,212.17,795.93,212.58,790.58,213.67"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.1502,
    y1: 184.7823,
    x2: 280.773,
    y2: 184.7823,
    gradientTransform: "matrix(1.0693 79.3069 -79.3069 1.0693 15075.6602 -22123.459)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D8C90"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "881.51,206.1 882.55,283.35 558.71,287.72 557.67,210.47  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    y: 115.55,
    width: 125.39,
    height: 234.45
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M125.39,265.31c-1.44,2.21-2.68,4.07-3.59,5.36c-2.84,3.96-30.31,43.23-57.27,65.33 c-5.84,4.79-11.67,8.78-17.22,11.41c-0.36,0.18-0.71,0.34-1.05,0.49c-0.31,0.14-0.6,0.28-0.89,0.41 c-1.49,0.63-2.94,1.15-4.37,1.56c-2.94,0.84-5.55-2.09-4.35-4.92c7.55-17.93,29.26-71.76,29.29-98.29 c0-0.71-0.02-1.43-0.03-2.14c-0.03-0.62-0.06-1.23-0.11-1.83c-0.03-0.57-0.08-1.14-0.15-1.7c-0.02-0.26-0.05-0.52-0.08-0.76 c-0.05-0.49-0.11-0.97-0.18-1.48c-0.08-0.66-0.19-1.33-0.31-1.99c-0.11-0.7-0.24-1.4-0.37-2.09l-0.39-1.85 c-0.03-0.15-0.06-0.28-0.1-0.42c-0.13-0.55-0.26-1.1-0.41-1.65c-0.23-0.91-0.47-1.8-0.73-2.69c-0.24-0.84-0.49-1.69-0.78-2.55 c-0.03-0.13-0.06-0.24-0.11-0.37c-0.11-0.34-0.23-0.7-0.34-1.06c-0.54-1.59-1.12-3.2-1.75-4.8c-0.18-0.5-0.37-0.99-0.58-1.48 c-1.83-4.56-4.01-9.15-6.43-13.74c-0.6-1.15-1.22-2.29-1.85-3.44c-0.37-0.68-0.76-1.38-1.15-2.06 c-2.06-3.67-4.27-7.34-6.56-10.99c-0.42-0.68-0.84-1.36-1.28-2.04c-1.38-2.16-2.79-4.33-4.2-6.48 c-1.17-1.78-2.37-3.55-3.55-5.3c-1.96-2.89-3.94-5.76-5.89-8.58c-0.65-0.94-1.3-1.87-1.95-2.81c-0.34-0.47-0.65-0.93-0.96-1.38 c-1.61-2.32-3.2-4.59-4.75-6.85c-2.3-5.44-2.27-11.26-2.27-11.26c-1.25,0-2.87,0.55-4.53,1.31h-0.02 c-4.01,1.88-8.28,5.03-8.28,5.03c2.01-8-1.74-15.98-4.32-26.19c-1.8-3.73-5.52-12.25,13.44-3.83c0.02,0.01,0.05,0.01,0.08,0.05 C19.23,121.37,107.3,181.52,125.39,265.31"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M444.49,5.57c-0.67,1.77-0.99,3.72-0.7,5.55c4.4,9.72,5.4,12.16,2.52,19.88 c-0.18,0.45-0.32,0.89-0.44,1.31c-1.77,5.7-0.03,8.52-0.21,15.06v0.11c-0.03,1.14-0.13,2.37-0.31,3.75v0.03 c-5.14,55.92-41.09,80.85-42.29,81.67c0.15-0.02,0.29-0.05,0.45-0.08c0.05-0.02,0.1-0.03,0.15-0.03 c8.47-2.32,16.39-4.37,23.6-6.1c0,0,0.4-0.1,1.2-0.26c4.67-1.02,22.7-4.82,47.86-8.54c27.2-4.01,62.75-7.95,98.78-8.23 c0.37,0,0.75-0.01,1.12,0c-23.29-4.62-40.54-16.97-57.56-41.18C498.3,39.6,477.71,9.96,460.49,2.11C457.2,0.6,454.55,0,452.42,0 C447.67,0,445.49,2.97,444.49,5.57"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.679,
    y1: 186.1149,
    x2: 279.3018,
    y2: 186.1149,
    gradientTransform: "matrix(18.0546 80.7705 -80.7705 18.0546 10492.874 -25793.5117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F7784"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5573,
    style: {
      stopColor: "#36545F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9933,
    style: {
      stopColor: "#27343A"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "567.97,-36.86 604.52,126.61 411.3,169.8 374.76,6.33  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_12_",
    d: "M445.35,51.23c0.18-1.38,0.28-2.61,0.31-3.75C445.58,48.75,445.48,50,445.35,51.23"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_13_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_12_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.329,
    y1: 232.5711,
    x2: 315.9518,
    y2: 232.5711,
    gradientTransform: "matrix(0.7243 3.2403 -3.2403 0.7243 970.6579 -1141.1172)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "445.65,47.42 446.46,51.05 445.37,51.3 444.56,47.66  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    d: "M347.54,281.48c0.1,0.03,0.19,0.05,0.31,0.05c0.11,0.02,0.21,0.02,0.32,0.02 c4.62,0.21,15.81-9.64,21.29-14.78l-1.93-0.19l-41.04-4.2C338.32,266.27,342.07,279.84,347.54,281.48"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.2154,
    y1: 179.8285,
    x2: 269.8382,
    y2: 179.8285,
    gradientTransform: "matrix(1.3631 -33.5314 33.5314 1.3631 -6049.8569 9077.8018)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "325.7,281.72 326.56,260.62 370.25,262.4 369.39,283.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_18_",
    d: "M264.06,217.09c-0.05,0-0.08,0-0.13,0.02c-27.8,2.08-62.02,7.74-87.43,10.45 c-25.46,2.71-37.6,13.49-45.06,28.9c4.02-5.48,8.68-10.9,13.27-13.58c9.15-5.32,53.36,0.28,53.88,0.28c0,0,0.02,0,0.05,0.02 c0.78,0.45,7.16,10.08,7.16,10.08c1.88,0.03,3.76,0.08,5.6,0.13c1.85,0.03,3.68,0.08,5.5,0.15c1.23,0.03,2.47,0.06,3.67,0.11 c3.38,0.1,6.67,0.23,9.9,0.37c1.95,0.08,3.88,0.16,5.78,0.26c3.78,0.18,7.46,0.39,11.05,0.6c1.87,0.12,3.7,0.23,5.52,0.36 c2.17,0.13,4.3,0.27,6.39,0.44c2.71,0.2,5.34,0.41,7.9,0.62c0.96,0.08,1.9,0.16,2.82,0.24c1.49,0.13,2.97,0.26,4.42,0.39 c2.53,0.24,5,0.49,7.38,0.73c0.1,0.02,0.21,0.03,0.29,0.03c3.18,0.33,6.25,0.67,9.15,1.02c0.66,0.06,1.33,0.15,1.98,0.23 c0.02,0,0.03,0,0.03,0.02c0.16,0.02,0.31,0.03,0.47,0.05l0.41,0.05l73.48,7.53l2.5,0.26c33.46,5.29,73.54,7.22,115.87,9.54 c7.43-7.04,12.61-12.88,14.26-15.25c5-7.17-1.35-10.57-1.35-10.57s12.27-6.02,33.53-10.58c0,0,12.01-5.23-6.57-9.02 c-21.91-4.48-110.46-11.42-226.78-14.07c-4.19-0.1-8.45-0.14-12.76-0.14C278.95,216.74,271.53,216.87,264.06,217.09"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_19_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_18_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.2238,
    y1: 186.9744,
    x2: 281.8465,
    y2: 186.9744,
    gradientTransform: "matrix(-3.802 60.1188 -60.1188 -3.802 12645.9766 -15920.9414)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D8C90"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "548.1,216.98 542.7,302.38 127.67,276.14 133.07,190.73  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M606.25,321.42c0.81,3.23,3.61,5.63,6.93,5.91c33.46,2.74,46.7-30.64,50.79-44.74 c-35.57,0.78-66.13-1.83-74.29-2.63C595.85,282.7,603.32,309.88,606.25,321.42"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 589.68,
    y1: 303.7245,
    x2: 663.97,
    y2: 303.7245
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F7784"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5573,
    style: {
      stopColor: "#36545F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9933,
    style: {
      stopColor: "#27343A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_22_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_23_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.5437,
    y1: 183.0636,
    x2: 274.1665,
    y2: 183.0636,
    gradientTransform: "matrix(-11.7624 -72 72 -11.7624 -9333.8613 22167.8555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F7784"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5573,
    style: {
      stopColor: "#36545F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9933,
    style: {
      stopColor: "#27343A"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "591.62,341.89 581.71,281.26 662.05,268.13 671.95,328.76  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M217.69,180.34c-1.07,6.04-4.93,11.21-6.78,13.41l26.01-8.78c-4.84-5.14-10.8-7.11-14.73-7.87 c-0.24-0.05-0.48-0.07-0.71-0.07C219.62,177.04,218.03,178.43,217.69,180.34"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.4025,
    y1: 191.8284,
    x2: 281.0253,
    y2: 191.8284,
    gradientTransform: "matrix(9.5157 34.1588 -34.1588 9.5157 4090.9153 -11280.6602)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2567,
    style: {
      stopColor: "#97A0A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "235.05,170.31 241.24,192.55 212.78,200.48 206.59,178.24  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_28_",
    x: 268.1,
    y: 149.17,
    width: 129.82,
    height: 44.58
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_29_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_28_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M391.09,164.28c-42.22,10.14-106.28,26.05-119.73,29.4c-1.41,0.35-2.82-0.5-3.18-1.91 c-0.34-1.32,0.37-2.68,1.65-3.14c13-4.69,79.39-28.41,122.03-39.31c3.07-0.79,6.06,1.54,6.06,4.71v1.57 C397.92,159.73,395.1,163.31,391.09,164.28"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_30_",
    x: 672.07,
    y: 182.54,
    width: 46.78,
    height: 33.35
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_31_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_30_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M681.36,207.57c5.11,3.71,10.91,6.59,15.92,7.85c12.73,3.2,26.64-10.24,19.74-21.41 c-5.46-8.84-22.67-11.42-32.97-11.47c-8.21-0.03-14.45,7.24-11.03,14.7C674.72,200.96,677.33,204.64,681.36,207.57"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_32_",
    d: "M804.97,221.38c0,0,0.02,0.02,0.03,0.02c-0.02-0.03-0.03-0.05-0.03-0.05V221.38z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_33_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_32_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 3958.2112,
    y1: 4566.8809,
    x2: 3959.834,
    y2: 4566.8809,
    gradientTransform: "matrix(0.0312 0.024 -0.024 0.0312 790.9279 -16.2457)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007AFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    style: {
      stopColor: "#007AFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0027FF"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "804.98,221.33 805.03,221.36 804.99,221.41 804.95,221.37  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_35_",
    x: 807.37,
    y: 189.91,
    width: 14.56,
    height: 10.51
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_37_",
    d: "M821.93,196.01v0.02c-0.29,0.99-1.04,2.71-3.59,3.83c-3.13,1.35-6.72,0.16-8.99-2.37 c-2.43-2.72-2.09-5.18-1.72-7.58c0.67,0.36,1.35,0.67,2.03,0.96L821.93,196.01z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.953,
    y1: 197.7457,
    x2: 298.5758,
    y2: 197.7457,
    gradientTransform: "matrix(5.1699 7.0691 -7.0691 5.1699 674.956 -2928.876)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#8E97A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "816.7,182.76 827.31,197.27 812.15,208.36 801.54,193.85  "
  }))))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M821.98,195.75c-0.43,2.16-2.33,3.8-4.64,3.8c-2.62,0-4.73-2.11-4.73-4.73c0-0.99,0.3-1.91,0.82-2.67L821.98,195.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_40_",
    d: "M798.27,182.84c3.18,3.46,7.07,6.2,11.4,8.02l24.88,10.46l-0.26-0.27c-3.58-3.73-7.89-6.69-12.66-8.69 l-23.81-10.02L798.27,182.84z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_41_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_40_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.8119,
    y1: 189.5489,
    x2: 281.4346,
    y2: 189.5489,
    gradientTransform: "matrix(27.8497 18.506 -18.506 27.8497 -3500.4739 -10286.3486)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    style: {
      stopColor: "#A1A9B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "809.06,165.41 843.29,188.16 823.29,218.26 789.06,195.51  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_43_",
    d: "M205.79,253.25c1.88,0.03,3.76,0.08,5.6,0.13c1.85,0.03,3.68,0.08,5.5,0.15 c1.23,0.03,2.47,0.06,3.67,0.11c3.38,0.1,6.67,0.23,9.9,0.37c1.95,0.08,3.88,0.16,5.78,0.26c3.78,0.18,7.46,0.39,11.05,0.6 c1.87,0.12,3.7,0.23,5.52,0.36c2.17,0.13,4.3,0.27,6.39,0.44c2.71,0.2,5.34,0.41,7.9,0.62c0.96,0.08,1.9,0.16,2.82,0.24 c1.49,0.13,2.97,0.26,4.42,0.39c2.53,0.24,5,0.49,7.38,0.73c-25.27-3.49-81.06-14.1-83.09-14.47 C199.41,243.63,205.79,253.25,205.79,253.25"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.5659,
    y1: 188.14,
    x2: 289.1888,
    y2: 188.14,
    gradientTransform: "matrix(-10.3366 23.7624 -23.7624 -10.3366 7692.4648 -4659.2314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "287.01,245.47 268.49,288.04 193.33,255.34 211.85,212.78  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_46_",
    d: "M293.14,258.93c-0.5-0.1-1.07-0.18-1.72-0.21c-0.08,0-0.16-0.02-0.26-0.02 C291.82,258.77,292.49,258.85,293.14,258.93"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_47_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_46_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 641.9062,
    y1: 461.1556,
    x2: 643.5291,
    y2: 461.1556,
    gradientTransform: "matrix(-9.937800e-03 0.6625 -0.6625 -9.937800e-03 604.0524 -162.3795)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3669,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "293.14,258.7 293.14,258.96 291.16,258.93 291.16,258.67  "
  })))), /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M774.27,242.77c12.13,2.47,31.52,6,44.67,9.69c0-0.56-0.18-1.23-0.33-1.89c-0.02-0.08,0.19-0.36-0.08-0.47 c-2.08-0.82-3.21-1.29-5.74-2.16c-7.73-2.66-17.98-6.02-25.16-9.3c-5.56-2.53-8.7-4.19-14.25-5.68 C769.91,236.34,764.47,240.78,774.27,242.77"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M833.97,236.2c2.33-2.06,6.62-2.72,5.89-7.31s-11.43-7.56-15.86-8.35c3.57,1.32,10.58,3.28,12.95,5.93 c3.86,4.32-0.51,7.09-3.44,9.56C833.6,236.09,833.72,236.07,833.97,236.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M764.22,238.79c-1.02,0.95-1.38,1.56-0.99,2.28c2.61,4.74,5.68,3.17,11.72,2.9 c6.05-0.27,18.81,5.18,25.89,6.18s14.58,3.39,20.69,4.31c2.16,0.33,2.16-0.05,2.71-0.45c0.55-0.4-0.06,0,0.08-0.1 s0.03,0,0.01-0.02c-1.6-1.51-3.66-2.48-5.69-3.3c0.11,0.64,0.21,1.28,0.4,1.91c-9.38-2.8-18.8-4.17-28.32-6.78 c-0.05-0.01,0.64,0.19-0.27-0.08c-0.91-0.27-4.58-1.35-6.14-1.94c-2.47-0.93-7.41-2.71-9.5-2.73c-3.98-0.05-6.53-1.45-4.62-4.25 c1.2-1.75,2.66-2.06,3.66-2.72c0.99-0.66,0.54-0.14,1.23-0.56c6.91,1.04,12.01,2.3,19.4,0.83c7.4-1.47,21.56-3.29,27.91,0.97 c3.14,2.11-0.49,2.05-0.07,3.74c1.97,0.03,3.77,0.34,5.99-0.37c1.08-0.35,2.8-0.36,4.1-1.53c5.85-5.28-1.18-9.06-9.74-10.4 s-28.29-1.58-38.06,1.33C776.29,230.48,769.93,233.51,764.22,238.79"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_49_",
    x: 770.25,
    y: 229.06,
    width: 58.05,
    height: 10.01
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M771.21,235.16c-1.21,0.87-0.2,0.58-0.96,1.39c0.89-1.04,2.71-2.17,3.6-2.59 c0.9-0.43,0.58-0.25,1.21-0.51c6.92,1.01,12.01,2.29,19.41,0.82c7.4-1.47,21.56-3.28,27.91,0.97c3.15,2.11-0.49,2.06-0.07,3.73 c1.9,0.21,3.85,0.09,5.99-0.27c-0.18-5.25-0.66-6.11-7.08-8.16c-8.51-2.71-25.86-1.11-33.93,0.18 C779.21,232.01,776.5,231.38,771.21,235.16"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M773.93,233.86c5.32,1.41,8.16,2.26,13.7,4.78c7.16,3.26,17.41,6.64,25.16,9.29 c2.53,0.87,3.55,1.35,5.81,2.16c-0.42-2.09,0.02-4.06,0.43-6.05c0.4-1.99,2.59-3.46,3.02-5.09c0.43-1.63,3.28-1.62,0.26-3.72 c-6.1-4.24-20.53-2.45-27.86-0.97c-7.33,1.48-12.5,0.18-19.41-0.81C774.69,233.54,774.38,233.78,773.93,233.86"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_51_",
    d: "M827,232.19c-2.76,2.04,1.15,8.01,1.24,10.74c2.31-1.5,3.8-3.75,4.05-6.54c0.19-2.2-1.49-4.81-3.57-4.81 C828.17,231.57,827.59,231.76,827,232.19"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_53_",
    cx: 268.2339,
    cy: 173.843,
    r: 1.6228,
    gradientTransform: "matrix(-14.7329 -9.3658 9.3658 -14.7329 3155.7874 5313.5312)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "830.12,246.66 819.1,239.66 826.62,227.84 837.63,234.84  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_54_",
    d: "M818.42,231.62c-1.32,2.82-2.09,5.82-1.97,8.97c2.88-1.79,8.52-3.71,7.71-8.28 c-0.22-1.25-1.77-2.26-3.25-2.26C819.92,230.05,818.95,230.5,818.42,231.62"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_55_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_54_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_56_",
    cx: 262.1374,
    cy: 178.2087,
    r: 1.6228,
    gradientTransform: "matrix(-6.9753 -13.2217 13.2217 -6.9753 294.7983 4946.8271)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "818.21,244.16 811.98,232.34 823.09,226.48 829.32,238.3  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_57_",
    d: "M811.02,228.84c-3.09,1.82-1.59,8.28-0.98,11.2c2.35-1.52,4.43-3.91,5.09-6.62 c0.54-2.21-0.47-5.06-2.54-5.06C812.12,228.35,811.59,228.5,811.02,228.84"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_58_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_57_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_59_",
    cx: 264.2913,
    cy: 177.2769,
    r: 1.6228,
    gradientTransform: "matrix(-9.2191 -13.6843 13.6843 -9.2191 823.7418 5488.0732)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "810.34,243.62 802.52,232 813.25,224.77 821.07,236.39  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_60_",
    d: "M804.65,236.62c-0.19-2.37,5.61-5.15,0.96-7.89c-0.72-0.43-1.35-0.61-1.89-0.61 C800.79,228.12,800.71,233.69,804.65,236.62"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_61_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_60_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_62_",
    cx: 264.8827,
    cy: 178.2242,
    r: 1.6228,
    gradientTransform: "matrix(-9.1358 -15.145 15.145 -9.1358 527.2228 5875.4683)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "803.26,240.85 796.95,230.39 807.71,223.89 814.02,234.36  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_63_",
    d: "M792.14,231.69c0.31,2.83,2.63,5.28,4.07,7.57c1.49-2.32,3.07-6.17,1.76-8.59 c-0.55-1.02-1.73-1.51-2.89-1.51C793.5,229.15,791.96,230.05,792.14,231.69"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_64_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_63_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_65_",
    cx: 291.3182,
    cy: 209.7568,
    r: 1.6228,
    gradientTransform: "matrix(6.8008 3.8005 -3.8005 6.8008 -390.1259 -2302.7537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "793.71,226.04 803.58,231.56 797.54,242.37 787.66,236.85  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_66_",
    d: "M786.14,231.66c-0.32,2.09,1.83,4.54,3.09,6.09c1.27-1.5,2.94-5.05,1.83-6.76 c-0.49-0.74-1.42-1.11-2.35-1.11C787.51,229.89,786.32,230.49,786.14,231.66"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_67_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_66_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_68_",
    cx: 289.7578,
    cy: 218.3824,
    r: 1.6228,
    gradientTransform: "matrix(5.8757 2.2169 -2.2169 5.8757 -429.9138 -1694.2487)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "786.61,227.79 794.77,230.87 791.38,239.85 783.22,236.77  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_69_",
    d: "M777.79,232.27c-0.42,1.42,2.79,3.19,3.94,3.8c1.11-0.94,2.89-2.52,2.67-4.09 c-0.09-0.69-1.3-0.99-2.66-0.99C780.01,230.99,778.03,231.48,777.79,232.27"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_70_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_69_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_71_",
    cx: 284.957,
    cy: 212.0008,
    r: 1.6228,
    gradientTransform: "matrix(7.5738 2.3632 -2.3632 7.5738 -877.7923 -2048.1003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "778.02,228.93 786.07,231.44 783.98,238.13 775.93,235.62  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_72_",
    x: 763.07,
    y: 238.89,
    width: 61.3,
    height: 15.62
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_73_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_72_",
    style: {
      overflow: "visible"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M764.04,238.89c-0.25,0.56-1.25,1.53-0.88,2.22c2.42,4.52,6.34,3.34,11.62,2.82 c3.52-0.35,11.3,3.06,15.56,4.4c0.78,0.25,2.91,0.67,4.1,0.89s4.76,0.73,5.55,0.84c0.75,0.11,0.19,0.02,0.21,0.03 c0.33,0.24,0.57,0.05,0.8,0.08c2.16,0.29,4.19,0.91,6.35,1.08c0,0,0.01,0,0.02,0.01c1.54,0.36,3.88,0.95,5.24,1.3 s3.12,0.78,3.92,0.98c0.59,0.15,0.13,0.03,0.14,0.03c1.4,0.34,2.65,0.57,3.97,0.77c0.49,0.07,0.79,0.09,1.29,0.15 s1.37,0,1.81-0.04c0.45-0.04,0.59-0.32,0.63-0.5c0.04-0.19,0,0,0.01-0.05s-0.01-0.01-0.01-0.01c-0.08-0.01-0.27,0.04-0.32,0.04 s-0.01,0-0.02,0c-1.19-0.02-1.69,0.3-2.85-0.26c-0.19-0.09-0.61-0.3-0.72-0.34c-0.12-0.04-0.03-0.01-0.04-0.01 c-1.11-0.34-2.02-0.46-3.18-0.56c-0.13-0.01-0.38-0.03-0.59-0.07c-1.84-0.32-3.63-1.07-5.41-1.58 c-0.56-0.16-0.84-0.16-1.44-0.19s-0.72-0.02-1.52-0.18c-2.8-0.54-6-1.18-8.96-1.55c-0.56-0.07-1.09-0.1-1.7-0.11 c-0.62-0.01-1.38-0.12-2.03-0.22c-2.29-0.37-4.65-1.2-6.68-2.14c-0.87-0.41-1.69-0.85-2.35-1.22c-1.5-0.86-4.36-1.35-5.49-1.56 c-1.13-0.2,0.56,0.1-0.38-0.06c-0.94-0.17-2.78-0.73-3.7-1.56c-0.1-0.09-0.25-0.17-0.3-0.21s-0.01-0.01-0.02-0.02 c-0.17-0.06-0.31-0.26-0.49-0.27c-2-0.12-3.68,1.04-5.74,0.82c-0.28-0.03-0.67-0.25-0.92-0.35c-2.31-0.95-5.66,0.36-5.5-2.86 C764.01,239.25,764.07,239.05,764.04,238.89"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_74_",
    d: "M823.98,253.91L823.98,253.91c-0.01,0.01,0.11,0,0.12,0S824.08,253.91,823.98,253.91 C823.99,253.91,823.98,253.91,823.98,253.91 M820.97,250.21c-0.36,0.82-0.98,2.41-0.66,2.96c0.17,0.29,0.13,0.22,0.09,0.15 c-0.02-0.03-0.03-0.06-0.03-0.06c0.23,0.13,0.62,0.28,0.77,0.38c0.89,0.59,2.12,0.27,2.71,0.27c0.05,0,0.09,0,0.12,0 c3.15-2.67,0.19-7.78-1.36-10.53C822.35,245.68,821.89,248.08,820.97,250.21"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_75_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_74_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_76_",
    cx: 287.6196,
    cy: 170.8878,
    r: 1.6228,
    gradientTransform: "matrix(-9.6633 9.3088 -9.3088 -9.6633 5194.9678 -776.7818)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "832.55,249.01 823.43,257.8 814.57,248.6 823.7,239.81  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_77_",
    d: "M770.42,242.63c1.09,0.1,2.08-0.16,3.07-0.42c0.86-0.23,1.73-0.45,2.66-0.44c0.14,0,0.12-0.04,0.26-0.2 c0.14-0.17,0.25-0.42-0.12-0.71c-0.01-0.01-0.02-0.01-0.02-0.02c-0.04-0.04-0.08-0.09-0.14-0.15c-0.61-0.64-1.91-3.73-2.05-5.1 C771.94,237.06,769.13,239.78,770.42,242.63"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_78_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_77_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_79_",
    cx: 299.0629,
    cy: 167.597,
    r: 1.6228,
    gradientTransform: "matrix(-4.9419 6.5269 -6.5269 -4.9419 3345.4529 -885.9804)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "780.1,238.19 773.92,246.36 765.69,240.12 771.87,231.96  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_80_",
    d: "M780.94,243.89c0.05-0.02,0.05-0.05-0.08-0.06C780.32,244.02,780.81,243.96,780.94,243.89  M776.27,240.89c0,0.04,0.03,0.08,0.04-0.04c-0.01,0-0.01,0-0.02,0C776.27,240.85,776.27,240.87,776.27,240.89 M777.42,239.12 c-0.69,0.39-1.08,1.07-1.11,1.69c0,0.02,0,0.03,0,0.05c0.01,0.01,0.03,0.02,0.05,0.04c0.14,0.18,0.25,0.49,0.09,0.69 c-0.15,0.2,0.17,0.39,0.19,0.46c0.01,0.05,0.01,0.04,0.01,0.03c0,0,0-0.01,0.01-0.01c0.1,0.06,0.2,0.14,0.31,0.22 c0.96,0.72,2.73,1.53,3.71,1.53c0.08,0,0.14,0,0.19,0c0.06-0.02,0.14-0.05,0.24-0.08c1.31-0.43,2.81-4.02,2.74-5.95 C781.64,237.81,779.41,237.98,777.42,239.12"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_81_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_80_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_82_",
    cx: 295.8211,
    cy: 162.1212,
    r: 1.6228,
    gradientTransform: "matrix(-5.8553 5.1966 -5.1966 -5.8553 3359.366 -349.1938)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "787,241.28 779.64,247.82 773.18,240.54 780.54,234  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_83_",
    d: "M812.51,243.76c1.25,2.27-0.75,4.53-1.49,6.63c-0.09,0.26-0.08,0.56,0.25,0.67 c1.64,0.59,3.59,1.28,5.36,1.6c0.19,0.03,0.49,0.16,0.58,0.03c0.32-0.45,0.15-1.96,0.07-2.34c-0.54-2.45-1.35-6.59-4.48-6.59 C812.71,243.75,812.61,243.76,812.51,243.76"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_84_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_83_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_85_",
    cx: 287.1765,
    cy: 171.4007,
    r: 1.6228,
    gradientTransform: "matrix(-10.1249 9.462 -9.462 -10.1249 5345.1738 -736.2178)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "822.05,248.6 814,256.12 806.4,247.98 814.45,240.46  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_86_",
    d: "M799.3,249.17c3.04,0.4,6.01,0.99,9.04,1.57c0.58-0.62,1.2-1.29,0.93-2.23 c-1.03-3.58-4.22-5.55-7.29-7.37C801.35,244.04,798.6,246.02,799.3,249.17"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_87_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_86_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_88_",
    cx: 285.2798,
    cy: 171.0741,
    r: 1.6228,
    gradientTransform: "matrix(-11.7376 8.5786 -8.5786 -11.7376 5621.5923 -196.1061)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "814.11,247.39 802.41,255.94 794.03,244.48 805.73,235.93  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_89_",
    d: "M788.58,244.13c-0.39,0.75,0.06,1.8,0.25,2.55c2.21,1,4.35,1.77,6.74,2.16c1.91-2.39,0.48-5.7-0.62-8.26 C792.8,241.3,789.69,241.97,788.58,244.13"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_90_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_89_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_91_",
    cx: 289.5486,
    cy: 166.8102,
    r: 1.6228,
    gradientTransform: "matrix(-8.3178 6.5712 -6.5712 -8.3178 4300.0767 -272.4308)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "801.5,245.66 791.76,253.35 784.18,243.75 793.91,236.05  "
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M824.4,254.13c-0.32,5.38-2.71,8.2-9.12,8.43c-6.41,0.23-15.29-4.16-22.42-3.79 c3.8-1.66,5.54-1.41,10.66-0.43c5.13,0.98,18.72,6.62,19.63-3.88C823.75,254.4,823.85,254.19,824.4,254.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M765.76,251.3c-3.52-0.29-8.29-1.53-9.65-4.7c-1.36-3.18-0.08-5.79,0.94-8.79 c-2.22,2.88-4.71,6.12-2.54,9.54C756.68,250.76,761.56,251.88,765.76,251.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_92_",
    d: "M577.56,109.68c-0.83,0-1.64,0-2.47,0.01c-36.03,0.28-71.58,4.22-98.78,8.23 c-25.15,3.72-43.18,7.51-47.86,8.54c-0.8,0.16-1.2,0.26-1.2,0.26c-80.38,19.34-249.44,78.27-276.93,87.91 c-3.05,1.07-6.44,0.62-9.07-1.27c-0.76-0.55-1.54-1.15-2.37-1.82c-7.64-6.18-17.28-16.66-17.28-16.66 c-2.08-2.17-4.19-4.3-6.35-6.39c-2.66-2.61-5.39-5.16-8.15-7.68c-24.71-22.39-52.56-40.44-72.54-51.62 c-8.02-4.5-14.75-7.89-19.52-10c-0.03-0.03-0.06-0.03-0.08-0.05c-18.95-8.42-15.24,0.1-13.44,3.83 c2.58,10.21,6.33,18.19,4.32,26.19c0,0,4.28-3.16,8.29-5.03c1.66-0.76,3.28-1.31,4.53-1.31c0,0-0.03,5.83,2.27,11.26 c19.96,28.84,45.03,62.82,45,92.57c-0.03,26.53-21.75,80.36-29.29,98.29c-1.2,2.82,1.41,5.76,4.35,4.92 c1.43-0.41,2.87-0.93,4.37-1.56c0.29-0.13,0.58-0.26,0.89-0.41c0.34-0.15,0.7-0.31,1.05-0.49c5.55-2.63,11.38-6.62,17.22-11.41 c26.95-22.1,54.43-61.37,57.27-65.33c0.91-1.28,2.14-3.15,3.58-5.35c1.72-2.65,3.78-5.76,6.05-8.85 c4.02-5.48,8.68-10.9,13.27-13.58c9.15-5.32,53.36,0.28,53.88,0.28s7.21,10.09,7.21,10.09c1.88,0.03,3.76,0.08,5.6,0.13 c1.85,0.03,3.68,0.08,5.5,0.15c1.23,0.03,2.47,0.06,3.67,0.11c3.37,0.1,6.67,0.23,9.9,0.37c1.95,0.08,3.88,0.16,5.78,0.26 c3.78,0.18,7.46,0.39,11.05,0.6c1.87,0.12,3.7,0.23,5.52,0.36c2.17,0.13,4.3,0.27,6.39,0.44c2.71,0.2,5.34,0.41,7.9,0.62 c0.96,0.08,1.9,0.16,2.82,0.24c1.49,0.13,2.97,0.26,4.41,0.39c7.04,0.67,13.49,1.36,19.31,2.08l0.41,0.05l73.48,7.53l2.5,0.26 c33.46,5.29,73.54,7.22,115.87,9.54c-12.14,11.5-30.3,26.19-48.88,34.06c0,0,20.9,8.73,59.65-4.66 c18.08-6.23,41.28-16.42,61.97-26.58c14.65,0.37,25.14,0.5,28.9,0.55c1.01,0.02,1.53,0.02,1.53,0.02 c0.21,0.03,0.42,0.1,0.62,0.19c8.16,0.8,38.72,3.41,74.29,2.63c0.52-0.02,1.06-0.03,1.61-0.05c0.45-0.03,0.91-0.05,1.4-0.08 c0.05,0,0.11,0,0.16-0.01c0.49-0.01,1.01-0.06,1.53-0.1c2.47-0.19,5.21-0.47,8.18-0.86c0.63-0.06,1.28-0.15,1.95-0.24 c1.59-0.21,3.23-0.44,4.92-0.7c0.99-0.14,2-0.31,3.02-0.47c4.58-0.71,9.48-1.56,14.59-2.52c1.69-0.32,3.39-0.63,5.11-0.97 c1.23-0.24,2.48-0.49,3.75-0.73c1.25-0.25,2.5-0.5,3.76-0.76c2.19-0.44,4.4-0.89,6.62-1.36c1.48-0.31,2.97-0.62,4.46-0.94 c1.22-0.26,2.43-0.52,3.65-0.8c3.15-0.66,6.28-1.36,9.41-2.06c1.17-0.26,2.34-0.52,3.51-0.8c2.14-0.47,4.27-0.96,6.38-1.44 c0.94-0.23,1.88-0.44,2.82-0.67c0.16-0.03,0.32-0.08,0.49-0.11c1.14-0.26,2.27-0.52,3.39-0.8c2.43-0.57,4.84-1.14,7.19-1.7 c1.31-0.32,2.63-0.63,3.91-0.94c3.31-0.81,6.51-1.59,9.56-2.35c0.47-0.12,0.94-0.23,1.41-0.36c2.32-0.57,4.54-1.13,6.67-1.69 c0.5-0.13,1.01-0.24,1.49-0.37c0.36-0.1,0.71-0.18,1.05-0.28c0.66-0.16,1.3-0.34,1.93-0.5c2.74-0.71,5.27-1.38,7.53-2 c0.54-0.15,1.04-0.28,1.54-0.42c4.92-1.35,8.34-2.37,9.72-2.89c0.7-0.26,1.38-0.55,2.04-0.83c0.03-0.02,0.06-0.03,0.1-0.05 c0.65-0.29,1.28-0.58,1.9-0.89c0.65-0.31,1.27-0.63,1.87-0.97c0.08-0.03,0.16-0.08,0.24-0.13c0.52-0.29,1.04-0.6,1.53-0.89 c0.54-0.32,1.05-0.67,1.56-0.99c0.53-0.36,1.04-0.73,1.54-1.09c0.39-0.29,0.78-0.59,1.15-0.89c0.36-0.29,0.71-0.57,1.05-0.86 c0.45-0.37,0.89-0.76,1.31-1.14c0.13-0.13,0.26-0.25,0.39-0.37c0.11-0.1,0.23-0.21,0.34-0.33c0.29-0.26,0.55-0.52,0.83-0.79 c0.26-0.26,0.52-0.54,0.78-0.8c0.37-0.37,0.71-0.75,1.06-1.12c0.42-0.47,0.83-0.94,1.2-1.4c0.68-0.85,1.32-1.66,1.87-2.45 c0.02-0.02,0.02-0.02,0.03-0.03c0.24-0.34,0.47-0.68,0.7-1.02l0.21-0.36l0.27-0.46l0.37-0.6l0.78-1.27l0.28-0.45l0.13-0.2 l0.06-0.11l1.14-1.87h0.01l1.2-1.98l0.05-0.08c0.03,0,0.05,0,0.08,0.02c0.06,0,0.14,0.02,0.21,0.02 c0.36,0.05,0.71,0.1,1.07,0.13c21.05,2.26,36.79-4.3,47.51-11.73c7.69-5.34,12.82-11.13,15.48-14.46c6.49-8.11,0-11.36,0-11.36 c-7.32-4.46-14.91-8.71-22.77-12.77c-4.35-2.24-8.78-4.43-13.27-6.54c-58.39-27.62-127.69-44.87-187.88-53.91 c-4.51-0.68-8.97-1.31-13.37-1.9c-0.67-0.08-1.33-0.18-2-0.26c-2.26-0.29-4.51-0.58-6.73-0.86c-1.43-0.18-2.87-0.34-4.29-0.52 c-1.43-0.16-2.85-0.32-4.25-0.47c-9.86-1.11-19.36-1.95-28.33-2.58c-1.28-0.1-2.56-0.18-3.83-0.26 c-7.35-0.47-14.33-0.78-20.9-0.94c-0.21,0-0.42-0.02-0.63-0.02c-2.09-0.05-4.12-0.08-6.12-0.1c-1.25-0.01-2.47-0.01-3.68-0.01 L577.56,109.68L577.56,109.68z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_93_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_92_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_94_",
    x: -1.2,
    y: 104.29,
    width: 902.92,
    height: 124.78
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_95_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_94_",
    style: {
      overflow: "visible"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M18.68,142.82c-1.2,0.1-2.33,0.56-3.43,1.04c-1.09,0.49-2.15,1.06-3.18,1.67 c-2.06,1.22-4.01,2.62-5.91,4.07l-1.01,0.77l0.18-1.29c0.55-3.92-0.09-7.94-0.94-11.85c-0.87-3.92-2.06-7.78-3.35-11.6 l-0.99-2.84c-0.35-0.94-0.74-1.93-1.01-3.04c-0.14-0.56-0.24-1.16-0.25-1.84c0-0.67,0.12-1.5,0.64-2.27 c0.52-0.78,1.36-1.23,2.04-1.42c0.71-0.21,1.35-0.25,1.96-0.24c2.39,0.07,4.41,0.69,6.43,1.32c2,0.65,3.93,1.41,5.84,2.21 l0.53,0.36c-0.29-0.28-0.49-0.33-0.52-0.36c-0.04-0.02,0,0,0.07,0.03c0.15,0.07,0.39,0.22,0.54,0.38l-0.54-0.37 c9.15,3.94,17.86,8.58,26.49,13.41c8.6,4.86,17.05,9.99,25.31,15.43c8.25,5.44,16.32,11.18,24.16,17.24 c7.82,6.07,15.51,12.38,22.74,19.19c3.68,3.3,7.25,6.89,10.74,10.39c3.36,3.47,6.83,6.88,10.35,10.14 c1.76,1.62,3.56,3.2,5.36,4.66c0.9,0.73,1.83,1.39,2.71,2.07c0.58,0.39,1.26,0.69,1.96,0.85c0.7,0.16,1.44,0.19,2.16,0.08 c0.36-0.05,0.71-0.13,1.05-0.25l1.63-0.58l6.94-2.5c18.5-6.64,37.03-13.2,55.59-19.7c37.17-12.83,74.42-25.42,111.9-37.42 c18.76-5.93,37.56-11.75,56.5-17.24c9.44-2.8,18.98-5.38,28.49-8l14.39-3.68l1.81-0.46l1.92-0.42l3.64-0.78l7.29-1.47 c19.44-3.76,38.99-6.72,58.63-9.09c19.64-2.33,39.37-4.03,59.18-4.76c4.95-0.18,9.92-0.33,14.85-0.37 c4.9-0.06,10.03-0.04,14.89,0.1c10.01,0.22,19.86,0.78,29.75,1.56c9.86,0.77,19.71,1.77,29.54,2.95 c4.94,0.58,9.78,1.25,14.67,1.91l14.69,2.19c39,6.32,77.61,15.21,115.2,27.39c18.79,6.09,37.3,13.1,55.37,21.09 c4.54,1.95,8.99,4.11,13.44,6.24c4.46,2.1,8.87,4.35,13.25,6.65c8.75,4.61,17.32,9.53,25.67,14.82l-0.14-0.08 c0.68,0.38,1.04,0.68,1.5,1.1c0.42,0.4,0.81,0.85,1.14,1.34c0.67,0.99,1.08,2.18,1.17,3.36c0.17,2.4-0.76,4.43-1.78,6.1 c-0.52,0.85-1.12,1.61-1.72,2.34c-0.58,0.7-1.19,1.38-1.79,2.06c-1.22,1.35-2.49,2.65-3.8,3.91 c-5.25,5.02-11.21,9.3-17.68,12.55c-6.45,3.28-13.44,5.44-20.55,6.46c-3.55,0.54-7.14,0.76-10.72,0.72 c-3.58,0.01-7.14-0.33-10.67-0.81l-0.21-0.02l0,0c-0.02-0.01-0.05-0.02-0.08-0.02c0.03,0,0.06,0,0.08,0.01l0.21,0.01l0,0 c3.55,0.31,7.11,0.47,10.66,0.28c3.55-0.14,7.08-0.53,10.55-1.24c6.95-1.34,13.63-3.82,19.76-7.23 c6.14-3.41,11.72-7.77,16.56-12.81c1.21-1.26,2.38-2.56,3.5-3.9c1.11-1.36,2.23-2.71,3-4.06c0.78-1.36,1.26-2.83,1.09-4.02 c-0.07-0.59-0.28-1.13-0.63-1.61c-0.17-0.24-0.38-0.47-0.61-0.67c-0.2-0.18-0.56-0.42-0.67-0.47l-0.03-0.01l-0.11-0.06 c-8.43-4.94-17.07-9.52-25.85-13.78c-4.4-2.12-8.81-4.19-13.31-6.12c-4.47-1.97-8.95-3.92-13.49-5.73 c-18.07-7.42-36.54-13.86-55.29-19.39c-18.75-5.51-37.68-10.4-56.78-14.53s-38.36-7.49-57.69-10.32l-14.48-1.99 c-4.85-0.6-9.75-1.21-14.58-1.73c-9.69-1.05-19.41-1.92-29.14-2.57c-9.7-0.65-19.48-1.09-29.12-1.19 c-4.97-0.07-9.66-0.04-14.58,0.07c-4.89,0.07-9.73,0.23-14.6,0.43c-38.91,1.68-77.79,6.72-116.08,14.07l-7.16,1.42l-3.57,0.74 l-1.68,0.36l-1.76,0.44l-14.18,3.57c-9.43,2.56-18.88,5.08-28.28,7.83c-18.83,5.37-37.59,11.1-56.31,16.95 c-37.48,11.6-74.84,23.69-112.1,36.09c-18.65,6.13-37.28,12.33-55.89,18.61l-6.97,2.36l-1.85,0.62 c-0.82,0.26-1.67,0.44-2.53,0.55c-1.72,0.21-3.48,0.1-5.16-0.33c-1.69-0.42-3.28-1.17-4.71-2.19 c-1.05-0.83-2.11-1.61-3.1-2.45c-1.98-1.67-3.84-3.37-5.67-5.11c-3.64-3.47-7.08-7.05-10.45-10.73 c-3.36-3.54-6.62-7.01-10.17-10.36c-13.86-13.59-29.17-25.78-45.12-37.02c-7.96-5.64-16.14-11-24.48-16.09 c-8.35-5.06-16.86-9.95-25.62-14.08l-0.54-0.37c0.13,0.14,0.34,0.27,0.46,0.33c0.06,0.03,0.09,0.04,0.03,0.01 c-0.04-0.03-0.26-0.09-0.56-0.38l0.53,0.36c-1.81-0.84-3.64-1.65-5.48-2.33c-1.82-0.67-3.74-1.28-5.42-1.4 c-0.85-0.07-1.47,0.15-1.52,0.28c-0.17,0.11-0.25,0.95-0.05,1.8c0.17,0.87,0.49,1.79,0.8,2.77c0.33,1.02,0.58,1.98,0.87,2.97 c1.09,3.95,2.08,7.94,2.75,12c0.63,4.05,1.02,8.26,0.16,12.39l-0.82-0.53c2.03-1.33,4.1-2.59,6.27-3.67 c1.08-0.54,2.19-1.04,3.33-1.45C16.29,143.22,17.47,142.83,18.68,142.82"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_96_",
    d: "M444.49,5.56c-0.67,1.77-0.99,3.72-0.7,5.55c13.36,84.32-39.27,120.81-40.73,121.82 c0.14-0.02,0.29-0.05,0.45-0.08c0.05-0.02,0.1-0.03,0.15-0.03c8.47-2.32,16.39-4.37,23.6-6.1c0,0,0.41-0.1,1.2-0.26 c4.67-1.02,22.7-4.82,47.86-8.54c27.2-4.01,62.75-7.95,98.78-8.23c0.37,0,0.75-0.01,1.12,0c-23.29-4.62-40.54-16.97-57.56-41.18 c-20.36-28.92-40.95-58.55-58.17-66.4C457.19,0.6,454.54,0,452.41,0C447.67,0,445.48,2.97,444.49,5.56"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_97_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_96_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_98_",
    x: 442.21,
    y: -2.88,
    width: 133.99,
    height: 112.58
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_99_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_98_",
    style: {
      overflow: "visible"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M445.03,20.51c-0.59-1.99-1.1-3.97-1.65-5.94l-0.75-2.96c-0.3-1.04-0.46-2.29-0.41-3.44 c0.09-2.32,0.68-4.63,2.15-6.79s4.12-3.7,6.71-4.08c2.59-0.41,5.04-0.06,7.29,0.48c2.29,0.52,4.31,1.42,6.38,2.38 c1.07,0.44,1.97,1.03,2.95,1.57c0.96,0.56,1.93,1.11,2.8,1.74l2.69,1.86l2.53,2c6.69,5.39,12.39,11.56,17.8,17.87 c5.39,6.33,10.38,12.89,15.22,19.53l7.09,10.04l6.87,10.14c4.38,6.65,9.09,12.93,14.3,18.77c1.28,1.48,2.68,2.83,4.02,4.27 c1.42,1.32,2.79,2.73,4.28,3.99c2.9,2.62,6.03,4.97,9.3,7.17c3.25,2.25,6.77,4.09,10.36,5.91c1.81,0.87,3.65,1.72,5.54,2.45 c1.86,0.86,3.81,1.45,5.72,2.24c-8.22-0.41-16.51-2.28-24.29-5.7c-3.86-1.73-7.65-3.74-11.17-6.14 c-3.57-2.34-6.92-5.01-10.07-7.86c-6.31-5.7-11.86-12.18-16.8-18.9l-7.22-9.85l-7.13-9.86c-4.73-6.57-9.49-13.07-14.37-19.41 c-4.88-6.32-9.88-12.54-15.37-18c-2.71-2.8-5.63-5.22-8.66-7.33c-3-2.04-6.52-3.71-9.48-3.82c-1.48-0.05-2.74,0.37-3.87,1.38 c-1.11,1.01-1.97,2.67-2.45,4.37c-0.23,0.88-0.34,1.68-0.3,2.65l0.05,3.1C445.06,16.4,445.09,18.46,445.03,20.51"
  }))))))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_100_",
    x: 429.21,
    y: 15.64,
    width: 55.5,
    height: 103.72
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_101_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_100_",
    style: {
      overflow: "visible"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M451.95,28.34c0.29,11.08-2.47,32.95-6.08,46.48s-11.13,31.17-15.76,40.72 c-4.63,9.54,9.54-1.73,17.35-2.03c7.81-0.29,49.74,1.74,33.55-7.23c-16.2-8.97-22.85-9.83-15.91-15.04s12.72-15.13,5.21-24.77 c-7.52-9.64-10.12-18.61-11.57-31.62C457.3,21.83,451.28,2.61,451.95,28.34"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_102_",
    x: 423.66,
    y: 138.94,
    width: 47.88,
    height: 15.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_103_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_102_",
    style: {
      overflow: "visible"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M429.21,142.82c-7.69,3.94-12.97,17.74,23.66,9.25c36.63-8.48,10.45-13.5-3.64-13.11 C435.13,139.35,434.47,140.12,429.21,142.82"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_104_",
    d: "M445.35,51.23c0.18-1.38,0.28-2.61,0.31-3.75C445.58,48.75,445.48,50,445.35,51.23"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_105_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_104_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.2337,
    y1: 242.4755,
    x2: 344.8565,
    y2: 242.4755,
    gradientTransform: "matrix(0.0804 2.3005 -2.3005 0.0804 975.6583 -761.6264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BCC2C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5573,
    style: {
      stopColor: "#6C7984"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C3E50"
    }
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "445.66,47.47 445.79,51.23 445.35,51.24 445.22,47.49  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M549,146.14c-2.36,7.94-4.51,15.96-5.8,24.13c-0.64,4.09-1.01,8.1-1.15,12.19c-0.13,4.09-0.02,8.05,0.33,12.12 c0.36,4.07,0.84,8.04,1.7,12.08c0.86,4.04,1.82,7.96,3.29,11.91c2.95,7.92,7.13,15.29,11.35,22.64 c-6.01-6.67-11.04-13.38-15.11-21.5c-0.38-0.76-0.91-2.02-1.29-2.96c-0.38-0.94-0.74-2.07-1.1-3.07c-0.36-1-0.7-2.08-0.98-3.11 c-0.29-1.04-0.69-2.07-0.9-3.12c-0.85-4.2-1.87-8.4-2.06-12.69c-0.38-8.6-0.01-16.88,1.98-25.27 C541.25,161.1,544.85,153.64,549,146.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.44,172.26c-0.7,3.92-1.11,7.79-1.3,11.74c-0.19,3.94-0.14,7.78,0.18,11.72c0.32,3.95,0.78,7.8,1.61,11.73 c0.83,3.92,1.77,7.75,3.2,11.6c2.87,7.7,6.92,14.9,11.02,22.04c-5.88-6.46-10.82-13.03-14.76-20.91c-0.4-0.79-0.89-1.96-1.27-2.89 c-0.38-0.94-0.74-2.01-1.09-3c-0.35-0.99-0.68-2.03-0.97-3.05c-0.29-1.02-0.66-2.04-0.88-3.07c-0.88-4.1-1.82-8.21-1.98-12.38 c-0.33-8.36,0.2-16.38,2.31-24.45c2.11-8.07,5.77-15.09,9.99-22.19C566.07,156.75,563.84,164.41,562.44,172.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.69,174.25c-0.75,3.76-1.22,7.48-1.46,11.29c-0.25,3.8-0.25,7.51,0.02,11.33c0.28,3.82,0.72,7.56,1.51,11.37 c0.79,3.81,1.71,7.55,3.11,11.29c2.8,7.48,6.7,14.51,10.69,21.45c-5.74-6.25-10.6-12.67-14.4-20.32c-0.41-0.82-0.88-1.9-1.25-2.82 c-0.38-0.93-0.74-1.96-1.08-2.93c-0.34-0.97-0.66-1.98-0.95-2.98c-0.29-1.01-0.62-2.01-0.86-3.02c-0.92-4-1.76-8.01-1.9-12.07 c-0.27-8.12,0.41-15.88,2.63-23.64c2.22-7.76,5.94-14.33,10.25-21.04C585.5,159.42,583.19,166.73,581.69,174.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.94,176.25c-0.8,3.6-1.32,7.17-1.62,10.83c-0.3,3.66-0.37,7.24-0.13,10.93c0.24,3.7,0.66,7.32,1.42,11.02 c0.76,3.7,1.66,7.34,3.02,10.97c2.72,7.26,6.48,14.12,10.36,20.86c-5.6-6.04-10.38-12.32-14.04-19.73 c-0.42-0.85-0.86-1.84-1.23-2.76c-0.38-0.93-0.73-1.91-1.07-2.86c-0.34-0.96-0.65-1.94-0.93-2.91c-0.29-0.99-0.59-1.98-0.83-2.97 c-0.95-3.89-1.7-7.82-1.81-11.75c-0.22-7.87,0.62-15.38,2.95-22.82c2.34-7.44,6.12-13.57,10.5-19.88 C604.93,162.09,602.54,169.04,600.94,176.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.03,158.19c-2.68,6.57-5.15,13.17-6.85,20.05c-0.85,3.44-1.42,6.86-1.78,10.38c-0.36,3.52-0.48,6.96-0.29,10.54 c0.2,3.58,0.61,7.09,1.33,10.67c0.73,3.59,1.61,7.14,2.93,10.66c2.65,7.05,6.26,13.73,10.03,20.26 c-5.47-5.83-10.16-11.96-13.69-19.15c-1.77-3.6-3.02-7.46-4-11.25c-0.98-3.79-1.65-7.63-1.73-11.44 c-0.17-7.63,0.82-14.88,3.27-22.01C618.72,169.8,622.57,164.11,627.03,158.19z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_107_",
    d: "M568.46,235.25c-42.9,2.19-69.65,15.3-69.65,15.3s6.35,3.39,1.35,10.57 c-1.66,2.37-6.83,8.21-14.26,15.25c-12.14,11.5-30.3,26.19-48.88,34.06c0,0,20.9,8.73,59.65-4.66 c18.08-6.23,41.28-16.42,61.97-26.58h0.02c0.73-0.36,1.46-0.71,2.19-1.07c16.88-8.34,31.85-16.55,40.7-22.41 c5.34-3.54,11.33-6.01,17.59-7.42c5.13-1.15,12.77-5.08,11.33-14.02v-0.05c-0.44-1.35-0.88-2.74-1.25-4.15L568.46,235.25z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.02,
    y1: 271.6482,
    x2: 630.6476,
    y2: 271.6482
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F7784"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5573,
    style: {
      stopColor: "#36545F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9933,
    style: {
      stopColor: "#27343A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_107_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_108_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_109_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_107_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.035,
    y1: 183.7112,
    x2: 278.6577,
    y2: 183.7112,
    gradientTransform: "matrix(-161.5842 115.9604 -115.9604 -161.5842 66781.2969 -2294.1919)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F7784"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5573,
    style: {
      stopColor: "#36545F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9933,
    style: {
      stopColor: "#27343A"
    }
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "674.11,288.88 503.27,411.49 394.81,260.36 565.65,137.76  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_111_",
    x: 455.38,
    y: 242.84,
    width: 94.15,
    height: 64.97
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_112_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_111_",
    style: {
      overflow: "visible"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M455.38,306.12c0,0,24.49-12.15,31.43-22.36c6.94-10.22,16.55-15.37,19.09-26.22 c2.54-10.86,6.55-3.09,13.11-7.33c6.55-4.24,16-10.19,19.47-5.87c3.47,4.33,18.9,9.92,5.98,13.19 c-12.92,3.28-21.59,0.96-26.22,8.87c-4.63,7.9-10.03,10.41-21.21,17.55c-11.18,7.13-8.62,10.71-21.79,14.65 C462.07,302.55,461.55,311.52,455.38,306.12"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_113_",
    d: "M568.46,235.25c-42.9,2.19-69.65,15.3-69.65,15.3s6.35,3.39,1.35,10.57 c-1.66,2.37-6.83,8.21-14.26,15.25c-12.14,11.5-30.3,26.19-48.88,34.06c0,0,20.9,8.73,59.65-4.66 c18.08-6.23,41.28-16.42,61.97-26.58h0.02c0.73-0.36,1.46-0.71,2.19-1.07c16.88-8.34,31.85-16.55,40.7-22.41 c5.34-3.54,11.33-6.01,17.59-7.42c5.13-1.15,12.77-5.08,11.33-14.02v-0.05c-0.44-1.35-0.88-2.74-1.25-4.15L568.46,235.25z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_114_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_113_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st48"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_115_",
    x: 430.93,
    y: 230.08,
    width: 200.49,
    height: 86.87
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_116_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_115_",
    style: {
      overflow: "visible"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M629.21,230.08c0.59,1.34,1.17,2.67,1.72,4l0.01,0.02l0.01,0.13l0.01,0.05l-0.01-0.08 c0.48,1.84,0.66,3.86,0.18,5.86c-0.45,1.99-1.49,3.89-2.91,5.4c-1.4,1.54-3.12,2.71-4.93,3.63c-1.78,0.96-3.9,1.51-5.45,2.06 c-3.32,1.18-6.51,2.62-9.51,4.34c-1.49,0.86-2.93,1.81-4.31,2.83c-1.41,1.05-3.01,2.22-4.53,3.28 c-6.21,4.2-12.55,8.08-18.95,11.84c-6.43,3.7-12.94,7.23-19.54,10.61l-1.01,0.52l-1.36,0.03h-0.02l2.38-0.55 c-9.58,4.92-19.31,9.54-29.19,13.86c-9.89,4.29-19.91,8.33-30.24,11.76c-10.37,3.44-21.24,6.14-32.32,6.92 c-2.76,0.26-5.54,0.34-8.32,0.37l-4.18-0.15c-1.39-0.07-2.78-0.22-4.17-0.33c-1.39-0.14-2.77-0.35-4.15-0.53 c-1.38-0.26-2.76-0.45-4.13-0.78c-2.77-0.65-5.35-1.4-8.18-2.66l-5.22-2.34l5.21-1.77c3.59-1.22,7.16-2.62,10.7-4.14 c3.52-1.56,7.03-3.21,10.52-4.96c-2.97,2.53-6.07,4.92-9.33,7.12c-3.24,2.22-6.62,4.28-10.16,6.09l-0.01-4.11 c2.19,0.59,4.86,0.98,7.37,1.16c1.26,0.15,2.56,0.17,3.82,0.26c1.29,0,2.56,0.05,3.85,0.02c5.14-0.1,10.26-0.68,15.34-1.54 c2.54-0.36,5.06-1.02,7.58-1.53c2.5-0.68,5-1.28,7.47-2.04s4.95-1.45,7.38-2.37c2.44-0.86,4.89-1.68,7.34-2.65 c9.8-3.79,19.56-7.91,29.26-12.18c9.7-4.26,19.36-8.66,28.98-13.16l1.24-0.58l1.14,0.02h0.02l-2.37,0.55 c3.33-1.53,6.6-3.08,9.89-4.67c3.3-1.56,6.59-3.13,9.86-4.75c6.57-3.17,13.1-6.41,19.41-9.92c1.62-0.86,3.1-1.69,4.77-2.65 c1.72-0.97,3.48-1.85,5.28-2.61c3.59-1.55,7.32-2.69,11.11-3.36c2.01-0.37,3.53-0.5,5.11-1.05c1.57-0.52,3.06-1.24,4.37-2.19 c1.31-0.96,2.36-2.23,3.02-3.74c0.65-1.51,0.93-3.26,0.86-5.04l-0.01-0.08l0.01-0.05l0.02,0.15 C629.72,232.94,629.45,231.51,629.21,230.08"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishResult2);
export default __webpack_public_path__ + "static/media/fish-result-2.3d69ba7e82d9228ae707996390653af4.svg";
export { ForwardRef as ReactComponent };